import { useState, useEffect } from 'react';

const IS_SERVER = typeof window === 'undefined';

function setStorageValue(key: string, value: any) {
  if (IS_SERVER) {
    return;
  }

  window.localStorage.setItem(key, JSON.stringify(value));
}

function getStorageValue(key: string, initialValue: any) {
  if (!IS_SERVER) {
    const value = window.localStorage.getItem(key);

    if (value) {
      return JSON.parse(value);
    }
  }

  if (initialValue instanceof Function) {
    return initialValue();
  }

  return initialValue;
}

export default function useLocalStorage(key: string, initialValue: any) {
  const [value, setValue] = useState(() => getStorageValue(key, initialValue));

  useEffect(() => {
    setStorageValue(key, value);
  }, [key, value]);

  return [value, setValue];
}
